// src/components/SetInitialTimeDialog.js

import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  Typography,
  Box,
} from '@mui/material';
import { parseTimeOfDayToSeconds, formatSecondsAsTimeOfDay } from '../utils';

const SetInitialTimeDialog = ({
  open,
  onClose,
  onSave,
  currentValueSeconds,
}) => {
  const [value, setValue] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (open) {
      setValue(currentValueSeconds != null ? formatSecondsAsTimeOfDay(currentValueSeconds) : '');
      setError('');
    }
  }, [open, currentValueSeconds]);

  const handleSave = () => {
    const parsed = parseTimeOfDayToSeconds(value);
    if (parsed == null) {
      setError('Մուտքագրեք ճիշտ ժամ՝ HH:MM:SS ձևաչափով');
      return;
    }
    onSave(parsed);
  };

  const handleClear = () => {
    onSave(null);
  };

  return (
    <Dialog open={open} onClose={onClose} disableScrollLock maxWidth="xs" fullWidth>
      <DialogTitle>Սահմանել սկզբնական ժամ</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
          Բոլոր ժամանակները կհաշվարկվեն այս սկզբնական ժամից սկսած։
        </Typography>
        <TextField
          autoFocus
          fullWidth
          type="time"
          label="Սկզբնական ժամ"
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
            if (error) setError('');
          }}
          inputProps={{ step: 1 }}
          InputLabelProps={{ shrink: true }}
          error={Boolean(error)}
          helperText={error || 'Օրինակ՝ 13:23:45'}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, justifyContent: 'space-between' }}>
        <Box>
          {currentValueSeconds != null && (
            <Button onClick={handleClear} color="error">
              Մաքրել
            </Button>
          )}
        </Box>
        <Box>
          <Button onClick={onClose} color="inherit">
            Չեղարկել
          </Button>
          <Button onClick={handleSave} variant="contained" color="primary" sx={{ ml: 1 }}>
            Պահպանել
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default SetInitialTimeDialog;
